<div class="client-migration">
  <a class="close" (click)="closeAllModals()">
    <img class="close-icon" src="/assets/images/icons/close-icon.png" alt="close-icon" />
  </a>
  <div class="popup add-client-modal">
    <div class="migration-title">Adding existing client</div>
    <form [formGroup]="addClientForm" class="add-client-form">
      <cc-input-text
        title="Client ID"
        placeholder="Enter existing client ID"
        [control]="addClientForm.controls.client_id"
        [isSubmitted]="formSubmitAttempt"
      ></cc-input-text>
      <cc-input-text
        title="Client Secret"
        placeholder="Enter client secret"
        [control]="addClientForm.controls.client_secret"
        [isSubmitted]="formSubmitAttempt"
      ></cc-input-text>
    </form>

    <div class="center">
      <sdc-design-button
        type="primary"
        (click)="confirmAddClient()"
        [disabled]="addClientForm.invalid"
        [title]="'Submit'"
        width="150px"
        height="40px"
      ></sdc-design-button>
    </div>
  </div>
</div>

<ng-template #migrateClientSuccess>
  <div class="client-migration-success">
    <a class="close" (click)="closeAllModals()">
      <img class="close-icon" src="/assets/images/icons/close-icon.png" alt="close-icon" />
    </a>
    <div class="popup add-client-modal">
      <div class="migration-title">Success!<br />Existing Client found</div>
      <form [formGroup]="successClientForm" class="success-client-form">
        <cc-input-text
          title="Client ID"
          placeholder="Enter existing client ID"
          [value]="validClient.client_id"
          [disabled]="true"
        ></cc-input-text>
        <cc-input-text
          title="Client Secret"
          placeholder="Enter client secret"
          [value]="validClient.client_secret"
          [disabled]="true"
        ></cc-input-text>
        <cc-input-text
          title="Client Name"
          placeholder="Enter client name"
          [(value)]="validClient.client_name"
          [disabled]="true"
        ></cc-input-text>
        <ng-container *ngIf="validClient.redirect_url">
          <cc-multiple-input
            title="Authorized Redirect URL"
            [controlArray]="redirectUrlForm.controls.redirect_url"
            [initialValue]="validClient.redirect_url"
            [maxListSize]="redirectUrlLimit"
            [maxLength]="maxRedirectUrlLength"
            [unlimitedSize]="isWeb"
            [isSubmitted]="true"
            [clientMigration]="true"
            [disabled]="true"
          >
          </cc-multiple-input>
        </ng-container>
        <div class="project-text">A new project will be automatically created for this client.</div>

        <cc-input-text
          title="Choose the new project name"
          placeholder="Enter new project name"
          [control]="successClientForm.controls.project_name"
          [isSubmitted]="formSubmitAttempt"
        ></cc-input-text>
      </form>
      <div class="center mt-2">
        <sdc-design-button
          type="primary"
          (click)="createProject()"
          [disabled]="successClientForm.invalid"
          [title]="'Add'"
          width="150px"
          height="40px"
        ></sdc-design-button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #migrateClientTryAgain>
  <div class="client-migration-tryagain">
    <a class="close" (click)="closeAllModals()">
      <img class="close-icon" src="/assets/images/icons/close-icon.png" alt="close-icon" />
    </a>
    <div class="warning-head">
      Client not found
    </div>
    <div class="warning-body" [innerHTML]="errorMessageTryAgain"></div>
    <div class="center">
      <sdc-design-button
        type="primary"
        (click)="handleMigrateClient()"
        title="Try again"
        width="120px"
        height="40px"
        [mat-dialog-close]
      ></sdc-design-button>
    </div>
  </div>
</ng-template>